import { useEffect } from 'react';
import { useIntl } from 'react-intl';

interface Options {
  separator?: string;
  shouldUseAppNameSuffix?: boolean;
}

const appTitleIntlId = 'appName';
const defaultSeparator = ' - ';

// Usage of this hook must not overlap on the same document,
// it should only be active in a single rendering component
export const useLocalizedDocumentTitle = (
  titlePartIntlIds: string[] | string | null,
  options: Options = {},
) => {
  const intl = useIntl();
  const { separator = defaultSeparator, shouldUseAppNameSuffix = false } = options;

  useEffect(() => {
    let allParts: string[] = [];
    if (Array.isArray(titlePartIntlIds)) {
      allParts = [...titlePartIntlIds];
    } else if (titlePartIntlIds) {
      allParts = [titlePartIntlIds];
    }

    if (shouldUseAppNameSuffix) {
      allParts.push(appTitleIntlId);
    }

    document.title = allParts
      .filter((translationId) => translationId)
      .map((id) => intl.formatMessage({ id }))
      .join(separator);
  }, [titlePartIntlIds, separator, intl, shouldUseAppNameSuffix]);
};
